import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {PluginModel} from '../../../models/api/pluginModel';
import {ThunkAction} from '../../appThunk';

/*
 * Action types.
 */

export enum PluginsActionsEnum {
  PLUGIN_UPDATED = '@@data/plugins/PLUGIN_UPDATED',
  PLUGIN_DELETED = '@@data/plugins/PLUGIN_DELETED',
}

/*
 * Types.
 */

export interface PluginUpdatedAction extends ActionWithPayload<PluginModel> {
  type: PluginsActionsEnum.PLUGIN_UPDATED;
}

export interface PluginDeletedAction extends ActionWithPayload<number> {
  type: PluginsActionsEnum.PLUGIN_DELETED;
}

/*
 * Actions creators.
 */

export function updatePlugin(newPlugin: PluginModel): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing plugin.
    const existingPlugin = getState().data.plugins[newPlugin.id];

    // No need to do anything if the new plugin is older.
    if (existingPlugin && existingPlugin.updatedAt > newPlugin.updatedAt) {
      return null;
    }

    const action: PluginUpdatedAction = {
      type: PluginsActionsEnum.PLUGIN_UPDATED,
      payload: newPlugin,
    };

    return dispatch(action);
  };
}

export function deletePlugin(pluginId: number): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing plugin.
    const existingPlugin = getState().data.plugins[pluginId];

    if (!existingPlugin) {
      return null;
    }

    const action: PluginDeletedAction = {
      type: PluginsActionsEnum.PLUGIN_DELETED,
      payload: pluginId,
    };

    return dispatch(action);
  };
}

/*
 * Union type.
 */

export type PluginsAction = PluginUpdatedAction | PluginDeletedAction;
